import { integer } from "aws-sdk/clients/lightsail";

class Utils {

    /**
     * returns a unique id but short
     * @returns {string}
     */
    getRandomIdShort = (): string => {
        const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
        return uint32.toString(16);
    }

    /**
     * returns a unique id but long
     * @returns {string}
     */
    getUuidv4 = (): string => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
    }

    sendMessageToParent = (functionName: string, functionData: any) => {
        window.parent.postMessage({
            'func': functionName,
            'message': functionData
        }, "*");
    }

    HTMLstrip = (html: string): string => {

        let doc = new DOMParser().parseFromString(html, 'text/html');

        if (doc.body.textContent && doc.body.textContent !== "") {
            return doc.body.textContent;
        }

        return doc.body.textContent || "";

    }

    Sleep = (milliseconds: integer) => {
        var start = new Date().getTime();
        for (var i = 0; i < 1e7; i++) {
            if ((new Date().getTime() - start) > milliseconds) {
                break;
            }
        }
    }

    mapChatMessageType = (fragment: any): string => {
        // Placeholder implementation for mapping chat message type
        return fragment.messageType || 'Unknown';
    }

    mapChatMessageFragment = (fragment: any): string => {
        // Placeholder implementation for mapping chat message fragment
        return fragment.props?.text || '';
    }

    detectAndTranslateLinks = (text : string) => {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
        return text.replace(urlPattern, (url) => {
            return `<a href="${url}" target="_blank">${url}</a>`;
        });
    };

    isValidEmail = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

}

// export Utils class instance (singleton)
export const __utils = new Utils();
